import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium border border-primary-300 text-primary-700 rounded-full mb-4 whitespace-nowrap">
            实时更新
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
            热门频道
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-md mx-auto">
            按兴趣浏览不同频道的精彩内容，找到你最想吃的瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const isPrimary = cat.color === 'primary';
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group block bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 transition-all duration-300 hover:bg-primary-500 hover:border-primary-500 cursor-pointer"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg mb-4 transition-colors duration-300 ${
                  isPrimary
                    ? 'bg-primary-100 text-primary-600 group-hover:bg-background-50/20 group-hover:text-background-50'
                    : 'bg-accent-100 text-accent-600 group-hover:bg-background-50/20 group-hover:text-background-50'
                }`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-background-50 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 group-hover:text-background-50/80 transition-colors">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500 group-hover:text-background-50/60 transition-colors whitespace-nowrap">
                    {cat.articleCount.toLocaleString()}篇文章
                  </span>
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-background-50/20 transition-colors">
                    <i className="ri-arrow-right-line text-sm text-foreground-500 group-hover:text-background-50 transition-colors"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}